import { isEmpty } from 'lodash/fp';

export default function SalinityData(currentMode, currentArea, datas, dataTime, thailandJson) {
  // eslint-disable-next-line no-unneeded-ternary
  const modeProvince = (currentMode === 'province' && currentArea.code > 0) ? true : false;

  const getProvinceCodeOrName = (prov) => {
    if (!isEmpty(thailandJson)) {
      return thailandJson.features
        .filter((d) => d.properties.prov_code === prov || d.properties.title === prov)
        // eslint-disable-next-line max-len
        .map((m) => ((m.properties.title === prov) ? m.properties.prov_code : m.properties.title)).toString();
    }
    return null;
  };

  // eslint-disable-next-line arrow-body-style
  // เพิ่ม slice(20) เพื่อให้คาดการณ์ความเค็มแสดงผลปกติ รอ พี่พีท ทำข้อมูลมาให้ใหม่
  const dataTable = datas.filter((d) => {
    // eslint-disable-next-line no-nested-ternary
    return (modeProvince
      ? (d.length > 1 && (getProvinceCodeOrName(d[3].replace('จ.', '')) === currentArea.code) ? d : false)
      : (d.length > 1 ? d : false)) && d[8] === 't';
  }).map((row) => ({
    maxsalinity: row[6],
    station_name: row[0],
    status: row[7],
    date: row[4],
    time: row[5],
    date_time: `${row[4]} ${row[5]}`,
    tambon_name: row[1],
    amphoe_name: row[2],
    province_name: row[3].replace('จ.', ''),
  }));

  // eslint-disable-next-line max-len
  const groupData = [...new Set(dataTable.map((d) => (modeProvince ? d.station_name : d.province_name)))].filter(Boolean);

  const countList = groupData.length;

  return ({
    count: countList,
    list: groupData,
    dataTable,
    dataTime,
  });
}
